// app/not-found.js
'use client';

import Link from "next/link";
import { useEffect, useState } from "react";

export default function NotFoundPage({blok}) {
  return (
    <main className="bg-asmPageTopBG bg-cover">
      <div className="px-6 pt-32 flex flex-col items-center bg-[url(/404-bg.svg)] bg-no-repeat bg-center pb-32 lg:pb-64">
        <div className="relative flex justify-center items-center">
          <h1 className="font-aileron text-9xl lg:text-[300px] font-bold text-[#5828E0]">404</h1>
          <img src="/404-ico.svg" className="absolute w-[32px] h-[42px] lg:w-[64px] lg:h-[72px] translate-y-[-30%]" />
        </div>
        <div className="font-lato flex flex-col gap-6 lg:block  lg:text-[32px] font-normal text-[#222222] text-center">
          <p>Oops! The page you’re looking for doesn’t exist or has been moved.</p>
          <p>Please navigate back or use the button below to continue.</p>
        </div>
        <Link href="/" className="bg-[#E56717] text-white px-6 py-3 rounded-md hover:bg-[#D76F1F] transition duration-150 mt-[38px]">Go Back to Homepage</Link>
      </div>
    </main>
  );
}
